import { useCallback } from "react";
import ReportService from "../../services/reportGeneration";
import { useSaveDownloaded } from "./useSaveDownloaded";

export const useExportTxt = (
  controllerName: string,
  fileName: string,
  onSuccess: () => void,
) => {
  const { save } = useSaveDownloaded(fileName, "text/plain");

  const onExport = useCallback(
    async (request: any) => {
      const res: any = await ReportService.exportByName(
        controllerName,
        request,
      );

      save(res);
      onSuccess();
    },
    [controllerName, save, onSuccess],
  );

  return { onExport };
};
